module.exports = __webpack_public_path__ + "assets/fe1eacb047be7848914e2400c2029872.svg";